import { faArrowDown } from '@fortawesome/pro-regular-svg-icons'
import Button from 'components/Button'
import Image from 'next/legacy/image'

interface IProps {
  onBrowseClick: Callback
}

function ExploreHero({ onBrowseClick }: IProps) {
  return (
    <div className="flex flex-col md:flex-row-reverse justify-between items-center py-20 md:py-8 px-5 md:px-10">
      <div className="pb-10 flex-1 flex justify-center items-center">
        <Image
          alt="Explore events"
          src="/static/events/explore_events.png"
          width={357}
          height={417}
        />
      </div>

      <div className="md:w-2/5 flex flex-col items-center md:items-start">
        <h1
          style={{ fontWeight: 900 }}
          className="text-6xl font-bold text-gray-800 tracking-tight text-center md:text-left pb-2"
        >
          Explore Upstream Crypto Events
        </h1>
        <p className="text-xl font-light text-gray-800 text-center md:text-left pt-5 pb-10">
          Attend crypto and web3-focused events around the world, meet new
          people, and learn about DAOs.
        </p>

        <Button
          label="Browse Events"
          icon={faArrowDown}
          color="transparent"
          size="xl"
          className="w-64"
          onClick={onBrowseClick}
        />
      </div>
    </div>
  )
}

export default ExploreHero
